import React from 'react';
import { Link } from "gatsby"
import PropTypes from 'prop-types';
import style from './style.module.scss';

const NavItem = props => {
    return (
        <Link to={props.link} className={style.link}>{props.children}</Link>
    );
};

NavItem.propTypes = {
    link: PropTypes.string,
};

NavItem.defaultProps = {
    link: '/',
    children: 'Link'
}

export default NavItem;